(function () {
    'use strict';

    angular.module('GorillaBoy.services')
    .factory('DateTimeService', ['$rootScope', 'DateFormatter', 'SignalProvider', '$translate',
        function ($rootScope, DateFormatter, SignalProvider, $translate) {
        var dateTimeService = {};

        var tOlder = $translate.instant('TIME_PERIOD.OLDER'),
            t3WeeksAgo = $translate.instant('TIME_PERIOD.WEEKS_AGO_3'),
            t2WeeksAgo = $translate.instant('TIME_PERIOD.WEEKS_AGO_2'),
            tLastWeek = $translate.instant('TIME_PERIOD.WEEKS_AGO_1'),
            tYesterday = $translate.instant('TIME_PERIOD.YESTERDAY'),
            tToday = $translate.instant('TIME_PERIOD.TODAY');
        
        var preferredLang = window.determinePreferredLanguage();

        /**
         * @param dateObj the primary date which you're getting labels for
         * @param today the base date on which labels are generated from. It's a param for  unit testing purposes
         */
        dateTimeService.getTimePeriod = function(dateObj, today) {
            
            if (!today) {
                today = new Date();
            } else {
                today = new Date(today); //clone it
            }

            dateObj = new Date(dateObj); //clone it
            dateObj.setHours(0,0,0,0); //ignore time part
            today.setHours(0,0,0,0);

            var todayMoment = moment(today),
                dateObjMoment = moment(dateObj),
                secsDuration = moment.duration((today.getTime() - dateObj.getTime())/1000, 'seconds'); //these don't need to be localized

            if (todayMoment.unix() === dateObjMoment.unix()) {
                return tToday;
            }
            if (moment.unix(todayMoment.unix()).subtract(1, 'days').unix() === dateObjMoment.unix()) {
                return tYesterday;
            }
            if (dateObjMoment.week() === todayMoment.week()) {
                return dateObj.toLocaleDateString(preferredLang, {weekday: 'long'});
            } else if (dateObjMoment.week() === moment.unix(todayMoment.unix()).subtract(1, 'week').week()){
                return tLastWeek;
            } else if (dateObjMoment.week() === moment.unix(todayMoment.unix()).subtract(2, 'week').week()){
                return t2WeeksAgo;
            } else if (dateObjMoment.week() === moment.unix(todayMoment.unix()).subtract(3, 'week').week()){
                return t3WeeksAgo;
            }
            return tOlder;
        };

        dateTimeService.memoizedDates = {};
        dateTimeService.getHumanReadableDate = function (date) {
            if (!date || date <= 0) {
                return '';
            }

            if (!dateTimeService.memoizedDates[date]) {
                dateTimeService.memoizedDates[date] = DateFormatter.toReadableDate(date);
            }

            return dateTimeService.memoizedDates[date];
        };
        
        $rootScope.$on(SignalProvider.DateTime.ClearMemoizedDates, function () {
            dateTimeService.memoizedDates = {};
        });

        return dateTimeService;
    }]);
}());
